import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const TabButtons = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 10px;
`;

const TabButton = styled.button.withConfig({
  shouldForwardProp: prop => !['isActive'].includes(prop),
})`
  height: 36px;
  padding: 4px 12px;
  border: none;
  cursor: pointer;
  border-radius: 8px;
  position: relative;
  color: ${props => (props.isActive ? 'var(--GrayScale-900)' : 'var(--GrayScale-600)')};
  background-color: ${props => (props.isActive ? '#f5f5f5' : '#ffffff')};
`;

const TabSection = ({ activeTab, setActiveTab }) => {
  const { t } = useTranslation('myInfo');

  return (
    <TabButtons>
      <TabButton className="body2Bold" isActive={activeTab === 0} onClick={() => setActiveTab(0)}>
        {t('address.tab.road')} {/*도로명 */}
      </TabButton>
      <TabButton className="body2Bold" isActive={activeTab === 1} onClick={() => setActiveTab(1)}>
        {t('address.tab.jibun')} {/*지번 */}
      </TabButton>
      <TabButton className="body2Bold" isActive={activeTab === 2} onClick={() => setActiveTab(2)}>
        직접입력 {/*직접입력 */}
      </TabButton>
    </TabButtons>
  );
};

export default TabSection;
